import React from "react";
import { useGetMyTasksQuery } from "../../../redux/slice/teachers/TeachersSlice";

const TaskCard = ({ task, color, keyword }) => {
  return (
    <div className={`bg-${color}-400 rounded-md shadow-md p-2 group relative`}>
      <div className="text-white">
        <h1 className="font-bold">{task?.task_title}</h1>
        <p>{task?.task_message}</p>
      </div>
      <div className="bg-white p-1 w-max rounded-md">
        <h1>
          {task?.from_user_object?.first_name
            ? task?.from_user_object?.first_name &&
              task?.from_user_object?.last_name
            : task?.from_user_object?.username}
        </h1>
      </div>
    </div>
  );
};

export default function MyTask() {
  const { data, isLoading } = useGetMyTasksQuery();

  const filterTasks = (data) => {
    return {
      yellow: data.filter(
        (task) => task.complete_to_user && !task.complete_from_user
      ),
      green: data.filter(
        (task) => task.complete_to_user && task.complete_from_user
      ),
    };
  };

  const allTasks = isLoading
    ? { red: [], yellow: [], green: [] }
    : filterTasks(data?.length > 0 ? data : []);

  return (
    <div className="grid grid-cols-2 h-[78vh] col-span-12">
      <div className="col-span-1 bg-yellow-100 border-2 p-1 flex flex-col gap-2 overflow-y-scroll">
        {allTasks.yellow.map((e) => (
          <TaskCard
            key={e.id}
            task={e}
            color="yellow"
            keyword="complete_from_user"
          />
        ))}
      </div>
      <div className="col-span-1 bg-green-100 border-2 border-l-0 p-1 flex flex-col gap-2 overflow-y-scroll">
        {allTasks.green.map((e) => (
          <TaskCard key={e.id} task={e} color="green" />
        ))}
      </div>
    </div>
  );
}
